/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthOtpResponseBaseResponse as ModelsAuthenticationAuthOtpResponseBaseResponse } from '../models/Models/Authentication/auth-otp-response-base-response';
import { AutocompleteAddressResponseBaseResponse as ModelsCustomerAutocompleteAddressResponseBaseResponse } from '../models/Models/Customer/autocomplete-address-response-base-response';
import { NzbnCompanyDetailsBaseResponse as ModelsCustomerNzbnCompanyDetailsBaseResponse } from '../models/Models/Customer/nzbn-company-details-base-response';
import { NzbnCompanyResponseBaseResponse as ModelsCustomerNzbnCompanyResponseBaseResponse } from '../models/Models/Customer/nzbn-company-response-base-response';
import { ApplicationConfigResponseBaseResponse as ModelsV4ApplicationApplicationConfigResponseBaseResponse } from '../models/Models/v4/Application/application-config-response-base-response';
import { LookupInternalResponseListBaseResponse as ModelsV4CommonLookupInternalResponseListBaseResponse } from '../models/Models/v4/Common/lookup-internal-response-list-base-response';
import { v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-json';
import { V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Params } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-json';
import { v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-plain';
import { V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Params } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-plain';
import { v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-xml';
import { V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Params } from '../fn/public-application/v-4-public-application-application-id-get-address-autocomplete-get-xml';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-json';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-json';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-plain';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-plain';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-xml';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-get-xml';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-json';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-json';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-plain';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-plain';
import { v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-xml';
import { V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Params } from '../fn/public-application/v-4-public-application-application-id-get-company-autocomplete-nzbn-get-xml';
import { v4PublicApplicationConfigGet$Json } from '../fn/public-application/v-4-public-application-config-get-json';
import { V4PublicApplicationConfigGet$Json$Params } from '../fn/public-application/v-4-public-application-config-get-json';
import { v4PublicApplicationConfigGet$Plain } from '../fn/public-application/v-4-public-application-config-get-plain';
import { V4PublicApplicationConfigGet$Plain$Params } from '../fn/public-application/v-4-public-application-config-get-plain';
import { v4PublicApplicationConfigGet$Xml } from '../fn/public-application/v-4-public-application-config-get-xml';
import { V4PublicApplicationConfigGet$Xml$Params } from '../fn/public-application/v-4-public-application-config-get-xml';
import { v4PublicApplicationLookupsApplicationIdCountriesGet$Json } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-json';
import { V4PublicApplicationLookupsApplicationIdCountriesGet$Json$Params } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-json';
import { v4PublicApplicationLookupsApplicationIdCountriesGet$Plain } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-plain';
import { V4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-plain';
import { v4PublicApplicationLookupsApplicationIdCountriesGet$Xml } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-xml';
import { V4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Params } from '../fn/public-application/v-4-public-application-lookups-application-id-countries-get-xml';
import { v4PublicApplicationStartOtpGet$Json } from '../fn/public-application/v-4-public-application-start-otp-get-json';
import { V4PublicApplicationStartOtpGet$Json$Params } from '../fn/public-application/v-4-public-application-start-otp-get-json';
import { v4PublicApplicationStartOtpGet$Plain } from '../fn/public-application/v-4-public-application-start-otp-get-plain';
import { V4PublicApplicationStartOtpGet$Plain$Params } from '../fn/public-application/v-4-public-application-start-otp-get-plain';
import { v4PublicApplicationStartOtpGet$Xml } from '../fn/public-application/v-4-public-application-start-otp-get-xml';
import { V4PublicApplicationStartOtpGet$Xml$Params } from '../fn/public-application/v-4-public-application-start-otp-get-xml';

@Injectable({ providedIn: 'root' })
export class PublicApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4PublicApplicationApplicationIdGetAddressAutocompleteGet()` */
  static readonly V4PublicApplicationApplicationIdGetAddressAutocompleteGetPath = '/v4/public/application/{applicationId}/getAddressAutocomplete';

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Response(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>): ModelsCustomerAutocompleteAddressResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Response(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>): ModelsCustomerAutocompleteAddressResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Response(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml(params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>): ModelsCustomerAutocompleteAddressResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet()` */
  static readonly V4PublicApplicationApplicationIdGetCompanyAutocompleteGetPath = '/v4/public/application/{applicationId}/getCompanyAutocomplete';

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets company starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet()` */
  static readonly V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGetPath = '/v4/public/application/{applicationId}/getCompanyAutocomplete/{nzbn}';

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyDetailsBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>): ModelsCustomerNzbnCompanyDetailsBaseResponse => r.body)
    );
  }

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyDetailsBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>): ModelsCustomerNzbnCompanyDetailsBaseResponse => r.body)
    );
  }

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Response(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>> {
    return v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Company Details by NZBN.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml(params: V4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyDetailsBaseResponse> {
    return this.v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>): ModelsCustomerNzbnCompanyDetailsBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationStartOtpGet()` */
  static readonly V4PublicApplicationStartOtpGetPath = '/v4/public/application/start-otp';

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationStartOtpGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Plain$Response(params?: V4PublicApplicationStartOtpGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>> {
    return v4PublicApplicationStartOtpGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationStartOtpGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Plain(params?: V4PublicApplicationStartOtpGet$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponseBaseResponse> {
    return this.v4PublicApplicationStartOtpGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>): ModelsAuthenticationAuthOtpResponseBaseResponse => r.body)
    );
  }

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationStartOtpGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Json$Response(params?: V4PublicApplicationStartOtpGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>> {
    return v4PublicApplicationStartOtpGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationStartOtpGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Json(params?: V4PublicApplicationStartOtpGet$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponseBaseResponse> {
    return this.v4PublicApplicationStartOtpGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>): ModelsAuthenticationAuthOtpResponseBaseResponse => r.body)
    );
  }

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationStartOtpGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Xml$Response(params?: V4PublicApplicationStartOtpGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>> {
    return v4PublicApplicationStartOtpGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate OTP code for application start.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationStartOtpGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationStartOtpGet$Xml(params?: V4PublicApplicationStartOtpGet$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthOtpResponseBaseResponse> {
    return this.v4PublicApplicationStartOtpGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthOtpResponseBaseResponse>): ModelsAuthenticationAuthOtpResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationConfigGet()` */
  static readonly V4PublicApplicationConfigGetPath = '/v4/public/application/config';

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationConfigGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Plain$Response(params?: V4PublicApplicationConfigGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>> {
    return v4PublicApplicationConfigGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationConfigGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Plain(params?: V4PublicApplicationConfigGet$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationConfigResponseBaseResponse> {
    return this.v4PublicApplicationConfigGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>): ModelsV4ApplicationApplicationConfigResponseBaseResponse => r.body)
    );
  }

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationConfigGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Json$Response(params?: V4PublicApplicationConfigGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>> {
    return v4PublicApplicationConfigGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationConfigGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Json(params?: V4PublicApplicationConfigGet$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationConfigResponseBaseResponse> {
    return this.v4PublicApplicationConfigGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>): ModelsV4ApplicationApplicationConfigResponseBaseResponse => r.body)
    );
  }

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationConfigGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Xml$Response(params?: V4PublicApplicationConfigGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>> {
    return v4PublicApplicationConfigGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the config settings for an application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationConfigGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationConfigGet$Xml(params?: V4PublicApplicationConfigGet$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationConfigResponseBaseResponse> {
    return this.v4PublicApplicationConfigGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationConfigResponseBaseResponse>): ModelsV4ApplicationApplicationConfigResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationLookupsApplicationIdCountriesGet()` */
  static readonly V4PublicApplicationLookupsApplicationIdCountriesGetPath = '/v4/public/application/lookups/{applicationId}/countries';

  /**
   * Get country list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationLookupsApplicationIdCountriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Response(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>> {
    return v4PublicApplicationLookupsApplicationIdCountriesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get country list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Plain(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Params, context?: HttpContext): Observable<ModelsV4CommonLookupInternalResponseListBaseResponse> {
    return this.v4PublicApplicationLookupsApplicationIdCountriesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>): ModelsV4CommonLookupInternalResponseListBaseResponse => r.body)
    );
  }

  /**
   * Get country list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationLookupsApplicationIdCountriesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Json$Response(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>> {
    return v4PublicApplicationLookupsApplicationIdCountriesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get country list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationLookupsApplicationIdCountriesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Json(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Json$Params, context?: HttpContext): Observable<ModelsV4CommonLookupInternalResponseListBaseResponse> {
    return this.v4PublicApplicationLookupsApplicationIdCountriesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>): ModelsV4CommonLookupInternalResponseListBaseResponse => r.body)
    );
  }

  /**
   * Get country list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationLookupsApplicationIdCountriesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Response(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>> {
    return v4PublicApplicationLookupsApplicationIdCountriesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get country list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationLookupsApplicationIdCountriesGet$Xml(params: V4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Params, context?: HttpContext): Observable<ModelsV4CommonLookupInternalResponseListBaseResponse> {
    return this.v4PublicApplicationLookupsApplicationIdCountriesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4CommonLookupInternalResponseListBaseResponse>): ModelsV4CommonLookupInternalResponseListBaseResponse => r.body)
    );
  }

}
